// alertsList.ts

export type DeformationFeature = 'coastal' | 'infrastructure (ancillary)' | 'infrastructure (core)' | 'water'

export interface DeformationDetails {
  threshold: number;
  measured: number;
  time_period: number;
  accuracy: number;
  feature: DeformationFeature;
  confidence: number;
}

export type ChangeFeature = 'coastal' | 'infrastructure (ancillary)' | 'infrastructure (core)' | 'vegetation' | 'water'

export interface ChangeDetectionDetails {
  priorFeature: ChangeFeature;
  currentFeature: ChangeFeature;
  pValue: number;
  confidence: number;
}

export interface Alert {
  id: string;
  type: 'deformation-rate' | 'change-detection';
  site: string;
  location: [number, number];
  likelihood: number;
  severity: number;
  startDate: string;
  details: DeformationDetails | ChangeDetectionDetails;
}

export const alerts: Alert[] = [
  // {
  //   id: '1',
  //   type: 'deformation-rate',
  //   site: 'Hinkley',
  //   location: [-3.134020,51.206553],
  //   likelihood: 0.8,
  //   severity: 0.6,
  //   startDate: '2018-12-24',
  //   details: {
  //     threshold: 1,
  //     measured: 1.2,
  //     time_period: 180,
  //     accuracy: 0.4,
  //     feature: 'infrastructure (core)',
  //     confidence: 55
  //   }
  // },
  // {
  //   id: '2',
  //   type: 'deformation-rate',
  //   site: 'Hinkley',
  //   location: [-3.137014,51.206453],
  //   likelihood: 0.8,
  //   severity: 0.6,
  //   startDate: '2018-12-24'
  // }
]

export const getAlerts = (): Alert[] => {
  return alerts
}
